export default `p.x-=4.;
    p=mod(p,8.)-4.;
    for(int j=0;j<3;j++){
      p.xy=abs(p.xy)-.3;
      p.yz=abs(p.yz)+.7,
      p.xz=abs(p.xz)-.2;
    }
    return length(cross(p,vec3(.5)))-.1;
  }`